import React, { useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import LayoutDashboard from 'app/private/layout';
import { withdraws as types } from '../../../../types';
import MaterialTable from 'components/table';
import { Root } from './index.styled';
import useGetWithdraws from './hooks/use-get-withdraws';
import columns from './index.columns';
import DialogAdd from './dialogs/add';
import Button from 'components/control/button/button';
import { Col } from 'components/layout/layout';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import useAppBarTitle from 'hooks/use-app-bar-title';
import { EPendingTaskTypeName } from '../../../../types/entities/pending-tasks';
import messages from 'messages';

const pageTitle = 'Withdraws';

const Withdraws = () => {
    useAppBarTitle(pageTitle);
    const { data, isLoading, refetch } = useGetWithdraws();
    const [isAddDialogOpen, setAddDialogOpen] = useState<boolean>(false);

    const handleOnSuccessMutation = useCallback(() => {
        refetch();
    }, [refetch]);

    const columnsList = useMemo(() => columns(), []);

    return (
        <>
            <LayoutDashboard>
                <Root>
                    <Button onClick={() => setAddDialogOpen(true)}>
                        <Col gap={0.5}>
                            <AddCircleOutlineIcon /> Create Withdrawal
                            Transaction
                        </Col>
                    </Button>

                    <MaterialTable<types.TWithdraws>
                        data={data}
                        columns={columnsList}
                        isLoading={isLoading}
                    />
                </Root>

                <DialogAdd
                    isDialogOpen={isAddDialogOpen}
                    setIsDialogOpen={setAddDialogOpen}
                    asyncStatesHandlers={{
                        onSuccess: () => {
                           
                            handleOnSuccessMutation();
                            toast.success(
                                messages.pendingTasks.onCreatePendingTask.onSuccess(EPendingTaskTypeName.CASH_WITHDRAWAL),
                                {
                                    pauseOnHover: true,
                                }, 
                            );
                        },
                        onError: (e: Error) => {
                            toast.error(`Error: ${e}`);
                            handleOnSuccessMutation();
                        },
                    }}
                />
            </LayoutDashboard>
        </>
    );
};

export default Withdraws;
